import { useEffect } from 'react';
// import { LocationListener, UnregisterCallback } from 'history';
import { AppWindow } from '@insurgrid/common';

export function bootIntercom(
  intercomId?: string,
  email?: string,
  intercomUserHash?: string,
) {
  const WINDOW = window as AppWindow;
  if (WINDOW.Intercom && WINDOW.analytics === null && intercomId) {
    WINDOW.Intercom('boot', {
      email,
      user_hash: intercomUserHash,
    });
    if (!WINDOW.intercomSettings) {
      WINDOW.intercomSettings = {
        app_id: intercomId,
        custom_launcher_selector: '#custom_intercom_button',
      };
    }
  }
  updateIntercom();
}

export function updateIntercom(intercomId?: string, intercomUserHash?: string) {
  const WINDOW = window as AppWindow;
  if (WINDOW.Intercom && intercomId) {
    WINDOW.Intercom?.('update', { user_hash: intercomUserHash });
  }
}

export function useIntercomFallback(
  intercomId?: string,
  email?: string,
  intercomUserHash?: string,
) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      bootIntercom(intercomId, email, intercomUserHash);
    }
  }, [window, window?.location?.pathname]);
}
